export const DefaultBookmarkedEntitiesForAgentPortal = [
  'patients',
  'providers',
  'payers',
  'plans',
  'case',
]

export const FIELD_VALUE_CONSTANTS = {
  ZERO: 0,
  ONE: 1,
  TWO: 2,
  FIVE: 5,
  TEN: 10,
  TWENTY_FIVE: 25,
  FIFTY: 50,
  FIFTY_NINE: 59,
  HUNDRED: 100,
  ONE_HUNDRED_SIXTY: 160,
  TWO_HUNDRED: 200,
  TWO_HUNDRED_FIFTY_FIVE: 255,
  FIVE_HUNDRED: 500,
  TWO_THOUSAND: 2000,
  MAXIMUM_ALLOWED_NUMBER: 2147483647,
  SIXTEEN: 16,
  EIGHT_FOUR_TWO: 842,
  TWENTY: 20,
  SEVEN: 7,
  ONE_HUNDRED_TEN: 110,
  TWO_FIFTY_FIVE: 255,
}

export const REDUX_PERSIST_CONSTANTS = {
  ROOT: 'root',
  AUTH_USER: 'authUser',
  /** Session credentials slice (sessionStorage). */
  SESSION: 'session',
  ROLE: 'role',
  TOAST: 'toast',
  TABLE_COLUMN: 'tableColumn',
  HCP_AUTH: 'hcpAuth',
  HCP_ONBOARDING: 'hcpOnboarding',
  AUTH_REMEMBER: 'authRemember',
  CALL_INTERACTOIN: 'callInteraction',
  PERMISSIONS: 'permissions',
  PAGINATION: 'pagination',
  CLIENT_PROGRAMS: 'clientPrograms',
  LOCAL_COMMON: 'localCommon',
  PERSIST: 'persist',
  AWS: 'awsCall',
}
export const PERMISSION_TYPE_CONSTANTS = {
  ADMIN: 'ADMIN',
  NONE: 'NONE',
} as const

export const INTEGRATION_TYPES = {
  MAXRTE: 'maxrte',
} as const
